function modifyFeatureLineup() {
  function cropText(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) : text;
  }

  function createContentWrapper(titleText, croppedTitle, descriptionText) {
    return `
      <h4 title="${titleText}" aria-label="${titleText}">${croppedTitle}</h4>
      ${descriptionText ? `<span>${descriptionText}</span>` : ''}
    `;
  }

  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find('.featureLineupImage');
    const $title = $element.find('.featureLineup-title');
    const $description = $element.find('.featureLineup-text').last();
    const $moreBtn = $element.find('.featureLineup-more');

    const titleText = $title.text().trim();
    const descriptionText = $description.text().trim();
    const croppedTitle = cropText(titleText, 20);

    const contentWrapper = createContentWrapper(titleText, croppedTitle, descriptionText);
    const wrapperAux = `<span class="featureLineup-text">${contentWrapper}</span>`;

    $title.remove();

    if ($description.length) {
      $description.html(contentWrapper);
      $description.append($moreBtn);
    } else {
      $imageContainer.append(wrapperAux);
      $imageContainer.find('.featureLineup-text').append($moreBtn);
    }
  });
}

function modifyBtnNavToggle() {
  const navToggle = document.querySelector('.mobile-nav-toggle');

  navToggle.innerHTML = `
    <span></span>
    <span></span>
    <span></span>
  `;
  navToggle.setAttribute('tabindex', '0');
  navToggle.setAttribute('role', 'button');
  navToggle.setAttribute('aria-label', 'open menu');
}

function modifyDirections() {
  const topLinks = $('.top-links');

  // If any li from top-links has the child element with the class 'directions', append the wrapper

  if (topLinks.find('.directionsPin').length) {
    // catch de father of the element with the class 'directions'
    const link = $('.standAloneDirections');
    const icon = $('.directionsPin').empty();
    icon.prependTo(link);
  }
}

function modifyCart() {
  var viewcart = $('.viewcart');
  var href = viewcart.find('.cartMenuLink').attr('href');

  var newLink = $('<a>', {
    href: href,
    class: 'viewcart',
  });

  newLink.html(viewcart.html());

  newLink.find('.cartMenuLink').replaceWith(function () {
    return $('<span>', {
      class: 'cartMenuLink',
      title: $(this).attr('title'),
      text: $(this).text(),
    });
  });

  viewcart.replaceWith(newLink);
}

function modifySignup() {
  const submitBtn = $('.emailSubmitButton');
  const directionsBtn = $('.standAloneDirections');
  const newsletterBtn = $('.signup-section-newsletter .button');
  const mapBtn = $('.signup-section-directions .button');

  // newsletterBtn on click event triggers submitBtn click event
  newsletterBtn.on('keypress click', function (e) {
    e.preventDefault();
    submitBtn.click();
  });

  mapBtn.attr('href', directionsBtn.attr('href'));
}

function prependLogo() {
  const body = $('body');
  const content = $('main.content');
  const logo = $('<span class="subpage-logo"></span>');

  // if body has not class homepage and class includes subpage* append logo to content
  if (!body.hasClass('homepage') && body.attr('class').includes('subpage')) {
    content.prepend(logo);
  }
}

function modifyLineupButton() {
  const item = $('.featureLineup-buynow .button');
  item.addClass('buyNowButton');
}

function offsetAnchorElements() {
  const anchorLinks = $('a[href^="#"] ');

  anchorLinks.on('click', function (event) {
    if (anchorLinks.id !== 'saffireMobileBackToTopLink') {
      event.preventDefault();
      var target = $(this.getAttribute('href'));
      if (target.length) {
        var offset = 130;
        var targetPosition = target.offset().top - offset;

        $('html, body').animate(
          {
            scrollTop: targetPosition,
          },
          1000,
        );
      }
    }
  });
}

$(document).ready(() => {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');

  modifyDirections();
  modifyBtnNavToggle();
  modifyFeatureLineup();
});

$(window).load(() => {
  // ---
  modifyCart();
  modifySignup();
  prependLogo();
  modifyLineupButton();
  offsetAnchorElements();
});
